exports.crownStatement = function () {
    $('#crown-statement-form').submit(function (event) {
        const formData = new FormData(event.target);
        const statement = formData.getAll('statement');

        if (statement.length > 1) {
            ga && ga('send', {
                hitType: 'event',
                eventCategory: 'Crown statement',
                eventAction: 'Multiple options chosen'
            });
        }

        if (statement.includes('crown-servant')) {
            ga && ga('send', {
                hitType: 'event',
                eventCategory: 'Crown statement',
                eventAction: 'Crown servant',
                eventLabel: 'User'
            });
        }

        if (statement.includes('spouse-crown')) {
            ga && ga('send', {
                hitType: 'event',
                eventCategory: 'Crown statement',
                eventAction: 'Crown servant',
                eventLabel: 'Spouse'
            });
        }

        if (statement.includes('british-council')) {
            ga && ga('send', {
                hitType: 'event',
                eventCategory: 'Crown statement',
                eventAction: 'British council',
                eventLabel: 'User'
            });
        }

        if (statement.includes('spouse-council')) {
            ga && ga('send', {
                hitType: 'event',
                eventCategory: 'Crown statement',
                eventAction: 'British council',
                eventLabel: 'Spouse'
            });
        }
    });
};
